import { reactive, ref } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { useRouter } from '@berlin-front/common/composables/useRouter';
import { ApiCacheContext } from '@/services/ApiCacheContext';
import { ROUTE_NAME } from '@/router/route-name';
import { SelectPaymentMethodContextType, UsablePattern, SPLIT_PATTERN_ONE, MESSAGE_COMMISSION_FREE } from './context';

export default {
  useSelectPaymentMethod: (): ReturnType<SelectPaymentMethodContextType['useSelectPaymentMethod']> => {
    const { atoneMethodGetResult, userFullName } = useContext(ApiCacheContext);
    const router = useRouter();

    // 商品合計金額
    const itemTotalAmount = atoneMethodGetResult.value?.splitPayment?.amount ?? 0;
    // 支払い回数のパターン
    const usablePatterns: UsablePattern[] = [
      // 通常決済
      {
        // 支払い回数のパターン
        splitPattern: SPLIT_PATTERN_ONE,
        // 支払い回数
        splitTimes: 1,
        // 1回あたりの支払い金額
        splitAmount: itemTotalAmount,
      },
      // 分割決済
      ...(atoneMethodGetResult.value?.splitPayment?.usablePatterns?.map((pattern) => ({
        // 支払い回数のパターン
        splitPattern: pattern.splitTimes,
        // 支払い回数
        splitTimes: pattern.splitAmounts.length,
        // 1回あたりの支払い金額
        splitAmount: pattern.splitAmounts[pattern.splitAmounts.length - 1].amount,
        // メッセージ（分割払いの場合は「分割手数料無料」と表示する）
        message: MESSAGE_COMMISSION_FREE,
      })) ?? []),
    ];
    // 選択されたパターン
    const selectedPattern = ref(usablePatterns[0]);

    // 「次へ」押下時のアクション
    const next = () => {
      if (selectedPattern.value.splitPattern === SPLIT_PATTERN_ONE) {
        void router.replace({ name: ROUTE_NAME.ATONE_SPLIT_SETTLEMENT_ONE_TIME });
      } else {
        void router.replace({
          name: ROUTE_NAME.ATONE_SPLIT_SETTLEMENT_SPLIT,
          query: { splitPattern: selectedPattern.value.splitPattern },
        });
      }
    };

    return reactive({
      itemTotalAmount,
      usablePatterns,
      selectedPattern,
      memberName: userFullName,
      next,
    });
  },
};
